'use strict';
const angular = require('angular');

const uiRouter = require('angular-ui-router');

import routes from './profile-picture-upload.routes';

export class ProfilePictureUploadComponent {
  /*@ngInject*/
  constructor($timeout, Upload, $state, User, Auth) {
    this.$timeout = $timeout;
    this.$state = $state;
    this.Upload = Upload;
    this.UserService = User;
    this.Auth = Auth;
  }

  upload(dataUrl, name) {

    var gotoProfile = () => {
      this.$state.go("profile");
    };

    this.Upload.upload({
      url: '/api/storage',
      data: {
        name: name,
        file: this.Upload.dataUrltoBlob(dataUrl, name),
        creationUser: this.Auth.getCurrentUserSync()._id
      }
    }).then(
      (res) => {

        var user = this.Auth.getCurrentUserSync();
        user.profile.picture = res.data;

        this.UserService.update(user,
          (user) => {
            //this.Auth.setCurrentUser(user);
            gotoProfile();
          },
          (err) => {
            alert('Could not set profile picture.');
          });
      },
      (err) => {
        alert('Could not upload profile image.');
      });

  }
}

export default angular.module('conduuApp.profile-picture-upload', [uiRouter])
  .config(routes)
  .component('profilePictureUpload', {
    template: require('./profile-picture-upload.html'),
    controller: ProfilePictureUploadComponent,
    controllerAs: 'ctrl'
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/user/profile-picture-upload/profile-picture-upload.component.js